export default "__VITE_ASSET__2e63f55c__"